import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Only redirects, so any signed-in user may open it: the dashboard checks its own access.
export const Route = createFileRoute('/_authenticated/next/projects/$projectId/')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/projects/$projectId/dashboard',
            params: { projectId: params.projectId },
            replace: true,
        });
    },
});
